import { Skeleton } from './skeleton';

const SkeletonButton = () => <Skeleton className="h-10 w-24" />;

const SkeletonBadge = ({ className = '' }: { className?: string }) => (
  <Skeleton className={`h-6 w-20 ${className}`} />
);

const SkeletonText = ({ className = '' }: { className?: string }) => (
  <Skeleton className={`h-4 ${className}`} />
);

const SkeletonTitle = ({ className = '' }: { className?: string }) => (
  <Skeleton className={`h-8 ${className}`} />
);

export { SkeletonButton, SkeletonBadge, SkeletonText, SkeletonTitle };
